var Dlrt;
(function (Dlrt) {
    class AjaxFormModal extends Dlrt.ModalBase {
        constructor(modal) {
            super(modal);
            this.form = modal.find('form').first();
            this.form.submit(e => this.onSubmit(e));
            this.initValidation();
        }
        get Form() {
            return this.form;
        }
        // work around typescript limitation that getter and setter must have same visibility => enforce protected setter by using a different property name
        set FormRef(form) {
            this.form = form;
        }
        initValidation() {
            // apparently, this is required when validating a form that was loaded dynamically
            this.form.removeData('validator');
            this.form.removeData('unobtrusiveValidator');
            $.validator.unobtrusive.parse(this.form);
        }
        onSubmit(e) {
            e.preventDefault();
            if (!this.form.valid()) {
                return;
            }
            const url = this.getSubmitUrl();
            const data = this.getFormData(this.form.serialize());
            $.ajax({
                url: url,
                method: 'POST',
                data: data,
                success: (data, status, jqXhr) => this.submitSuccess.apply(this, [data, status, jqXhr]),
                error: (jqXhr, message, error) => this.submitFailure.apply(this, [jqXhr, message, error])
            });
        }
        submitSuccess(data, status, jqXhr) {
            if (this.onSubmitSuccess(data, status, jqXhr)) {
                this.hide();
            }
        }
        submitFailure(jqXhr, message, error) {
            if (this.onSubmitFailure(jqXhr, message, error)) {
                this.handleValidationError(jqXhr);
            }
        }
        getFormData(initialData) {
            return initialData;
        }
        onSubmitSuccess(data, status, jqXhr) {
            return true;
        }
        onSubmitFailure(jqXhr, message, error) {
            return true;
        }
        handleValidationError(jqXhr) {
            // if server-side validation fails, we actually receive a 400 status code with full model state
            // => in this case, update all validation info accordingly
            if (jqXhr.status === 400 && typeof (jqXhr.responseJSON) === 'object') {
                DelphiCustomValidation.addModelStateErrors(this.form, jqXhr.responseJSON);
            }
        }
    }
    Dlrt.AjaxFormModal = AjaxFormModal;
})(Dlrt || (Dlrt = {}));

//# sourceMappingURL=ajaxFormModal.js.map
